import Nav from './components/layout/Nav';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Hero from './components/sections/Hero';
import About from './components/sections/About';
import Media from './components/sections/Media';
import Brands from './components/sections/Brands';
import Outreach from './components/sections/Outreach';
import Ventures from './components/sections/Ventures';
import Contact from './components/sections/Contact';

function App() {
  return (
    <>
      <Nav />
      <Header />
      <main>
        <Hero />
        <About />
        <Media />
        <Brands />
        <Outreach />
        <Ventures />
        <Contact />
      </main>
      <Footer />
    </>
  );
}

export default App;
